// Mirror Prisma enums (string-equivalent, framework-agnostic).
// These are the SAME values as @prisma/client enums — keep in sync manually.

export const UserRole = {
  EMPRESA: 'EMPRESA',
  PROFISSIONAL: 'PROFISSIONAL',
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const EmpresaRole = {
  ADMINISTRADOR: 'ADMINISTRADOR',
  COLABORADOR: 'COLABORADOR',
  VISUALIZADOR: 'VISUALIZADOR',
} as const;
export type EmpresaRole = (typeof EmpresaRole)[keyof typeof EmpresaRole];

export const Funcao = {
  MONTADOR: 'MONTADOR',
  TECNICO: 'TECNICO',
  CARREGADOR: 'CARREGADOR',
} as const;
export type Funcao = (typeof Funcao)[keyof typeof Funcao];

export const EventoStatus = {
  rascunho: 'rascunho',
  publicado: 'publicado',
  em_andamento: 'em_andamento',
  finalizado: 'finalizado',
  cancelado: 'cancelado',
  pausado: 'pausado',
} as const;
export type EventoStatus = (typeof EventoStatus)[keyof typeof EventoStatus];

export const TipoContratacao = {
  ABERTO: 'ABERTO',
  SELECAO: 'SELECAO',
} as const;
export type TipoContratacao = (typeof TipoContratacao)[keyof typeof TipoContratacao];

export const CandidaturaStatus = {
  pendente: 'pendente',
  aprovada: 'aprovada',
  rejeitada: 'rejeitada',
  concluida: 'concluida',
  cancelada: 'cancelada',
  cancelada_empresa: 'cancelada_empresa',
} as const;
export type CandidaturaStatus = (typeof CandidaturaStatus)[keyof typeof CandidaturaStatus];

export const OwnerType = {
  EMPRESA: 'EMPRESA',
  PROFISSIONAL: 'PROFISSIONAL',
  PLATAFORMA: 'PLATAFORMA',
} as const;
export type OwnerType = (typeof OwnerType)[keyof typeof OwnerType];

export const MovimentacaoTipo = {
  CREDITO_PENDENTE: 'CREDITO_PENDENTE',
  LIBERACAO: 'LIBERACAO',
  DEBITO: 'DEBITO',
  TAXA_PLATAFORMA: 'TAXA_PLATAFORMA',
  ESTORNO: 'ESTORNO',
} as const;
export type MovimentacaoTipo = (typeof MovimentacaoTipo)[keyof typeof MovimentacaoTipo];

export const MovimentacaoStatus = {
  PENDENTE: 'PENDENTE',
  LIBERADA: 'LIBERADA',
  CANCELADA: 'CANCELADA',
} as const;
export type MovimentacaoStatus = (typeof MovimentacaoStatus)[keyof typeof MovimentacaoStatus];

export const NotificationKind = {
  CANDIDATURA_CRIADA: 'CANDIDATURA_CRIADA',
  CANDIDATURA_APROVADA: 'CANDIDATURA_APROVADA',
  CANDIDATURA_REJEITADA: 'CANDIDATURA_REJEITADA',
  CANDIDATURA_CANCELADA: 'CANDIDATURA_CANCELADA',
  CANDIDATURA_CANCELADA_PROFISSIONAL: 'CANDIDATURA_CANCELADA_PROFISSIONAL',
  CANDIDATURA_CANCELADA_EMPRESA: 'CANDIDATURA_CANCELADA_EMPRESA',
  EVENTO_PROXIMO: 'EVENTO_PROXIMO',
  EVENTO_FINALIZADO: 'EVENTO_FINALIZADO',
  EQUIPE_CONVITE: 'EQUIPE_CONVITE',
  CARTEIRA_CREDITO: 'CARTEIRA_CREDITO',
  // GENERICO retained for backwards compat with historical rows (Phase 39
  // KYC-SPLIT-01 is additive — never DROPped). New code uses one of the
  // dedicated kinds below.
  GENERICO: 'GENERICO',
  // Phase 26 — CONVOCAR + bilateral rating reminder.
  CONVOCACAO_RECEBIDA: 'CONVOCACAO_RECEBIDA',
  CONVOCACAO_CANCELADA: 'CONVOCACAO_CANCELADA',
  AVALIACAO_PENDENTE: 'AVALIACAO_PENDENTE',
  // Phase 33 v1.7 — SUP-01. Founder reply to a support ticket.
  SUPORTE_RESPOSTA: 'SUPORTE_RESPOSTA',
  // Phase 39 v1.9 — KYC-SPLIT-01. Dedicated kinds replacing GENERICO.
  KYC_REJEITADA: 'KYC_REJEITADA',
  SISTEMA_AVISO: 'SISTEMA_AVISO',
  PIX_EXPIROU: 'PIX_EXPIROU',
} as const;
export type NotificationKind = (typeof NotificationKind)[keyof typeof NotificationKind];

export const ConsentScope = {
  TERMOS_DE_USO: 'TERMOS_DE_USO',
  POLITICA_PRIVACIDADE: 'POLITICA_PRIVACIDADE',
  MARKETING_EMAIL: 'MARKETING_EMAIL',
  MARKETING_WHATSAPP: 'MARKETING_WHATSAPP',
} as const;
export type ConsentScope = (typeof ConsentScope)[keyof typeof ConsentScope];
